export default __webpack_public_path__ + "static/nested-grid-dark-82dfdb2dff5223058e86c3978f55b077.png";